import { configureStore } from '@reduxjs/toolkit'
import { CatClientes } from '../Components/Catalogos/CatClientes'
import { MenuItemsSlice } from './features/Auth/MenuItemsSlice'
import { UserProfileSlice } from './features/Auth/UserProfileSlice'
import { CatClientesSlice } from './features/Catalogos/CatClientesSlice'
import { CatProveedoresSlice } from './features/Catalogos/CatProveedoresSlice'
import { CatServiciosSlice } from './features/Catalogos/CatServiciosSlice'
import { CatTipoUnidadesSlice } from './features/Catalogos/CatTipoUnidadesSlice'
import { CatUbicacionesSlice } from './features/Catalogos/CatUbicacionesSlice'
import { CatAduanasSlice } from './features/Catalogos/CatAduanasSlice'
import { OpViajesSlice } from './features/Operaciones/OpViajesSlice'
import { OpViajesServiciosSlice } from './features/Operaciones/OpViajesServiciosSlice'
import { OpViajesEstatusSecuenciaSlice } from './features/Operaciones/OpViajes.Estatus.SecuenciaSlice'

export const store = configureStore({
  reducer: {
    MenuItems: MenuItemsSlice.reducer,
    UserProfile: UserProfileSlice.reducer,
    CatClientes: CatClientesSlice.reducer,
    CatProveedores: CatProveedoresSlice.reducer,
    CatTipoUnidades: CatTipoUnidadesSlice.reducer,
    CatUbicaciones: CatUbicacionesSlice.reducer,
    CatServicios: CatServiciosSlice.reducer,
    CatAduanas : CatAduanasSlice.reducer,
    OpViajes: OpViajesSlice.reducer,
    OpViajesServicios: OpViajesServiciosSlice.reducer,
    OpViajesEstatusSecuencia: OpViajesEstatusSecuenciaSlice.reducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store